(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Diet', Diet);

    Diet.$inject = ['$resource', 'DateUtils'];

    function Diet ($resource, DateUtils) {
        var resourceUrl =  'api/diets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT'},
            "findAllByChart":{url: 'api/diets/by-chart', method: 'GET', isArray: true}
        });
    }
})();
